export default "__VITE_ASSET__BuZowtj4__"